import React from 'react';
import './Contact.css';

const Contact = ({ data }) => {
    return (
        <section className="contact section bg-light" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>
                <p className="section-intro">{data.intro}</p>

                <div className="contact-grid">
                    {data.cards.map((card, index) => (
                        <div key={index} className="contact-card">
                            <div className="contact-icon">
                                {index === 0 && <i className="fas fa-envelope"></i>}
                                {index === 1 && <i className="fas fa-user-plus"></i>}
                                {index === 2 && <i className="fas fa-share-alt"></i>}
                            </div>
                            <h3>{card.title}</h3>
                            {card.lines && (
                                <div className="contact-info">
                                    {card.lines.map((line, lineIndex) => (
                                        <p key={lineIndex}>{line}</p>
                                    ))}
                                </div>
                            )}
                            {card.links && (
                                <div className="contact-links">
                                    {card.links.map((link, linkIndex) => (
                                        <a
                                            key={linkIndex}
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="social-link"
                                        >
                                            <i className="fab fa-facebook"></i>
                                            {link.label}
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="contact-cta">
                    <h3>Get in Touch</h3>
                    <p>We'd love to hear from you. Reach out to us for any questions or information.</p>
                    <a href="mailto:mncwestv@gmail.com" className="btn btn-primary">
                        <i className="fas fa-paper-plane"></i> Send us an Email
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Contact;
